import type { ReactNode } from 'react';
import { Flex } from '@repo/ui/Flex';
import s from './Callout.module.css';
import { CalloutIcon } from './CalloutIcon';

export const calloutVariantOptions = ['info'] as const;
export type CalloutVariant = (typeof calloutVariantOptions)[number];

export type CalloutProps = {
  children?: ReactNode;
  variant?: CalloutVariant;
};

export const Callout = (props: CalloutProps) => {
  const { children, variant = 'info' } = props;

  return (
    <Flex
      className={s.container}
      gap="g-16"
      padding={['py-8', 'px-16']}
      alignItems="center"
    >
      <CalloutIcon variant={variant} />
      {children}
    </Flex>
  );
};
